import React from "react";
import { useRouter } from "next/router";
import { isProspect } from "@/utils/type";

import CaliforniaSearchPage from "../components/search/CaliforniaSearchPage";
import NotFound from "@/components/common/NotFound";

const Search = ({ type, community }) => {
    const router = useRouter();

    return isProspect(type) ? <CaliforniaSearchPage /> : <NotFound />;
};

// can use getStaticProps without getStaticPath, so use getServerSideProps here
export async function getServerSideProps(context) {
    // This is a special landing page for California search
    // it show communities in 3 cities: Sacramento, Los Angeles, and San Diego

    return {
        props: {
            type: process.env.NEXT_PUBLIC_TYPE,
            meta: {
                title: "California | Purple Door",
                description: "Search for California on Purple Door",
                ogTitle: "California | Purple Door",
                ogImage:
                    "https://cdn.purpledoorfinders.com/purpledoorfinders/logo-for-meta-data.sm.webp",
                ogType: "profile",
            },
        },
    };
}

export default Search;
